<template>
  <div>
    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>

    <v-dialog v-model="showConfirmDialog" max-width="500px">
      <LoadingDialog v-model="showLoadingDialog" />

      <v-card v-if="!!paymentInfo && planToConfirm">
        <v-card-title class="pa-2 mb-3">
          <div class="add-on-heading">
            <div class="add-on-title txt-bold itoviEden--text" style="font-size: 24px;">Change Plan To {{ planToConfirm.name }}?</div>
            <span flat icon color="itoviGrayMid" @click="$store.commit('setShowConfirmDialog', false);"><v-icon>close</v-icon></span>
          </div>
        </v-card-title>
        <v-card-text class="pt-0 text-xs-left">
          <div class="mt-2 text-sm-center pl-2 pr-2" >
            Your card ending in <b>{{ paymentInfo.last_four }}</b> will be charged
            <span v-if="planToConfirm.price > 0">
              <b>${{formatPrice(planToConfirm.price)}}</b> today
            </span>
            {{ planToConfirm.price > 0 && planToConfirm.monthly > 0 ? 'and ' : '' }}
            <span v-if="planToConfirm.monthly > 0">
              <b>${{formatPrice(planToConfirm.monthly)}}</b> monthly, starting next month.
            </span>
          </div>
          <div class="mt-2 text-sm-center">
            <span class="txt-button-blue txt-bold" @click="openCcDialog()">
                Update Card
              </span>
          </div>

          <v-layout justify-center wrap class="mt-4">
            <button class="button-blue" @click="submitPlanChange">Pay ${{ planToConfirm.price }} Now</button>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<style lang="scss" scoped>
  .plan-title {
    font-size: 15pt;
    color: #027689;
  }
</style>

<script>
  import api from "../../../services/api_endpoints"
  import store from "../../../store"
  import LoadingDialog from "../../LoadingDialog"
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      LoadingDialog
    },
    data: ()=> ({
      showLoadingDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
      },
      showConfirmDialog: store.state.showConfirmDialog,
      planToConfirm: store.state.planToConfirm,
      planDetails: store.state.planDetails,
      showUpdateCcDialog: store.state.showUpdateCcDialog,
      familyRegex: /FAMILY\+[0-9]+/,
      plusOneClients: store.state.plusOneClients,
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      paymentInfo: {
        type: Object,
        default: ()=> ({})
      },
      onClose: {
        type: Function,
        default: ()=> ({})
      }
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['planDetails', 'planToConfirm', 'showConfirmDialog', 'showUpdateCcDialog', 'plusOneClients']);
    },
    methods: {
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      async submitPlanChange() {
        // the the payment info so we can tell the user what card they are paying with
        this.payment_info = store.state.ccInfo
        const successMessage = this.generateSuccessMessage();

        this.showLoadingDialog = true
        let response = await api.submitPlanChange(this.planToConfirm.product_code);
        if (response.success) await this.removePlusOneClients();
        this.showLoadingDialog = false
        if (response.success) {
          this.snackbar.success = true;
          store.commit('setShowConfirmDialog', false);
          store.commit('setShowManagePlanDialog', false);
          store.commit('setShowSuccessDialog', {active: true, message: successMessage})
          await api.refreshDashboard();
        } else {
          if (response.errorMessage !== '') this.snackbar.errorMessage = response.errorMessage
          this.snackbar.error = true
        }
        if (this.isFunction(this.onClose)) this.onClose(response.success)
      },
      openCcDialog() {
        this.$store.commit('setShowUpdateCcDialog', true)
      },
      generateSuccessMessage() {
        let message = 'Your plan has been changed successfully and a receipt has been sent to your email.';

        //Check if user is swapping family plan or larger size
        if (this.planDetails.product_code.match(this.familyRegex) && this.planToConfirm.product_code.match(this.familyRegex)) {
          message = `(${Number(this.planToConfirm.product_code.split('+')[1]) - Number(this.planDetails.product_code.split('+')[1])}) ` +
              'contacts have been added to your plan and a receipt has been sent to your email. Open the iTOVi app to assign people to your account';
        }

        return message;
      },
      async removePlusOneClients() {
        if (this.planToConfirm.product_code.match(this.familyRegex)) return;
        const promises = [];
        this.plusOneClients.clients.forEach((client) => (!client.expires_on) ? promises.push(api.deletePlusOne(client.id)) : null);
        await Promise.all(promises);
      },
    }
  }
</script>
